import easeInOut from './easeInOut';

/**
 * @desc 运行动画。
 * @param {number} start 开始数字
 * @param {number} end 结束数字
 * @param {number} [duration=300] 动画运行时长 ms
 * @param {number} callback 动画过程中每一帧执行的回调函数
 * @returns {function} cancel 取消函数
 *
 * @example
 * let cancel;
 * if (cancel) cancel();
 * cancel = animate({ start: 0, end: 100, callback: (value: number) => domRef.current.scrollLeft = value });
 */
interface PropsType {
    start: number;
    end: number;
    duration?: number;
    callback: (value: number) => void;
}
export default function animate({ start, end, duration = 300, callback }: PropsType) {
    const startTime = Date.now();

    const delta = end - start;

    let rafId: number | undefined;

    const tick = () => {
        const elapsed = Date.now() - startTime;

        // 使用缓动函数求值
        const value = easeInOut(elapsed, start, delta, duration);

        callback(value);

        rafId = elapsed < duration ? requestAnimationFrame(tick) : undefined;
    };

    tick();

    return () => rafId && cancelAnimationFrame(rafId);
}
